/* eslint-disable react/no-array-index-key */
import React from 'react';
import Heading from './Heading';

function JsDocExample(_ref) {
  var definition = _ref.definition,
      level = _ref.level;
  var examples = definition.examples && definition.examples.length ? definition.examples : definition.type && definition.type.typeDef;

  if (examples && examples.length) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
      level: level
    }, "Example"), definition.examples.map(function (example, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: "gatsby-highlight"
      }, /*#__PURE__*/React.createElement("pre", {
        key: "example " + i,
        className: "language-javascript"
      }, /*#__PURE__*/React.createElement("code", {
        className: "language-javascript",
        dangerouslySetInnerHTML: {
          __html: example.highlighted
        }
      })));
    }));
  }

  return null;
}

export default JsDocExample;
export var fragment = "295553801";